<div class="grid-box">
  <div class="list-grid"><app-message-list (clickMessage)="fetchMessage($event)"></app-message-list></div>
  <div class="message-grid"><app-message class="message-card" [message]="message"></app-message></div>
</div>
